// extracted by mini-css-extract-plugin
export default {"item__container":"card-item_item__container__rpwdI","btnDeletePhoto":"card-item_btnDeletePhoto__yeJL5"};